import React from "react";
import Cookies from "universal-cookie";

function CerrarSesion() {
  const cookie = new Cookies();

  const cerrarSecion = () => {
    cookie.remove("id", { path: "/" });
    cookie.remove("Nombre", { path: "/" });
    cookie.remove("correo", { path: "/" });
    cookie.remove("contrasena", { path: "/" });
    cookie.remove("tipo_Usuario", { path: "/" });
    cookie.remove("institucionid", { path: "/" });
    cookie.remove("Rol", { path: "/" });
    window.location.href = "/";
  };
  return (
    <button className="btn btn-secondary" onClick={cerrarSecion}>
      Cerrar Sesion
    </button>
  );
}
export default CerrarSesion;
